import React from "react";

export default ({ width = 16, height = 16, ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.33203 4.66732C3.15522 4.66732 2.98565 4.73756 2.86063 4.86258C2.7356 4.9876 2.66536 5.15717 2.66536 5.33398V12.6673C2.66536 12.8441 2.7356 13.0137 2.86063 13.1387C2.98565 13.2637 3.15522 13.334 3.33203 13.334H10.6654C10.8422 13.334 11.0117 13.2637 11.1368 13.1387C11.2618 13.0137 11.332 12.8441 11.332 12.6673V8.66732C11.332 8.29913 11.6305 8.00065 11.9987 8.00065C12.3669 8.00065 12.6654 8.29913 12.6654 8.66732V12.6673C12.6654 13.1978 12.4546 13.7065 12.0796 14.0815C11.7045 14.4566 11.1958 14.6673 10.6654 14.6673H3.33203C2.8016 14.6673 2.29289 14.4566 1.91782 14.0815C1.54274 13.7065 1.33203 13.1978 1.33203 12.6673V5.33398C1.33203 4.80355 1.54274 4.29484 1.91782 3.91977C2.29289 3.5447 2.8016 3.33398 3.33203 3.33398H7.33203C7.70022 3.33398 7.9987 3.63246 7.9987 4.00065C7.9987 4.36884 7.70022 4.66732 7.33203 4.66732H3.33203Z"
        fill="#18A0FB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.33203 2.00065C9.33203 1.63246 9.63051 1.33398 9.9987 1.33398H13.9987C14.3669 1.33398 14.6654 1.63246 14.6654 2.00065V6.00065C14.6654 6.36884 14.3669 6.66732 13.9987 6.66732C13.6305 6.66732 13.332 6.36884 13.332 6.00065V2.66732H9.9987C9.63051 2.66732 9.33203 2.36884 9.33203 2.00065Z"
        fill="#18A0FB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4714 1.52925C14.7318 1.7896 14.7318 2.21171 14.4714 2.47206L7.13807 9.80539C6.87772 10.0657 6.45561 10.0657 6.19526 9.80539C5.93491 9.54504 5.93491 9.12293 6.19526 8.86258L13.5286 1.52925C13.7889 1.2689 14.2111 1.2689 14.4714 1.52925Z"
        fill="#18A0FB"
      />
    </svg>
  );
};
